(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("dFSGc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0f5b2696a4a3e6$export$2e2bcd8739ae039; });

var $cCnLl = parcelRequire("cCnLl");


const $1f0f5b2696a4a3e6$var$createSnowplowV2Tracker = async (input)=>{
    const loadImpressionHandler = async ()=>{
        return await (parcelRequire("8sxXd")).then(({ default: load })=>load());
    };
    const loadEcommerceHandler = async ()=>{
        return await (parcelRequire("1hjWl")).then(({ default: load })=>load(input));
    };
    return {
        context: input,
        initialize: $cCnLl.initialize,
        // Load ecommerce handler only if the event is a transaction or if no event is specified
        ecommerce: (input.event === "transaction" || !input.event) && await loadEcommerceHandler(),
        impressions: input.event === "impression" && await loadImpressionHandler(),
        trackSignup (input) {
            const { uuid: uuid, firstName: firstName, lastName: lastName, gender: gender, emailAddress: emailAddress, hashedEmailAddress: hashedEmailAddress, address: address, city: city, state: state, phoneNumber: phoneNumber, advertiser: advertiser } = input;
            window.tracker("trackSelfDescribingEvent", {
                event: {
                    schema: "iglu:com.mediajel.events/sign_up/jsonschema/1-0-2",
                    data: {
                        uuid: uuid,
                        firstName: firstName,
                        lastName: lastName,
                        gender: gender,
                        emailAddress: emailAddress,
                        hashedEmailAddress: hashedEmailAddress,
                        address: address,
                        city: city,
                        state: state,
                        phoneNumber: phoneNumber,
                        advertiser: advertiser
                    }
                }
            });
        },
        record (input) {
            window.tracker("trackSelfDescribingEvent", {
                event: {
                    schema: "iglu:com.mediajel.events/record/jsonschema/1-0-2",
                    data: input
                }
            });
        }
    };
};
var $1f0f5b2696a4a3e6$export$2e2bcd8739ae039 = $1f0f5b2696a4a3e6$var$createSnowplowV2Tracker;

});
parcelRegister("cCnLl", function(module, exports) {

$parcel$export(module.exports, "initialize", function () { return $9d8a97e293d4eea9$export$2a47f398eeff8b01; });

var $lwczO = parcelRequire("lwczO");
const $9d8a97e293d4eea9$export$2a47f398eeff8b01 = ({ appId: appId, collector: collector, event: event, sdkUrl: sdkUrl })=>{
    (0, $lwczO.default).debug(`SDK URL: ${sdkUrl}`);
    (function(e, o, n, t, a, c, i) {
        if (!e[a]) {
            e.GlobalSnowplowNamespace = e.GlobalSnowplowNamespace || [];
            e.GlobalSnowplowNamespace.push(a);
            e[a] = function() {
                (e[a].q = e[a].q || []).push(arguments);
            };
            e[a].q = e[a].q || [];
            c = o.createElement(n);
            i = o.getElementsByTagName(n)[0];
            c.async = 1;
            c.src = t;
            i.parentNode.insertBefore(c, i);
        }
    })(window, document, "script", "//mj-snowplow-static-js.s3.amazonaws.com/cnna.js", "tracker");
    window.tracker("newTracker", appId, collector, {
        appId: appId,
        postPath: "/analytics/track",
        discoverRootDomain: true,
        stateStorageStrategy: "cookieAndLocalStorage",
        cookieSameSite: "Lax",
        respectDoNotTrack: false,
        eventMethod: "post"
    });
    window.tracker("enableActivityTracking", {
        minimumVisitLength: 30,
        heartbeatDelay: 10
    });
    window.tracker("trackPageView");
    window.tracker("enableFormTracking");
    window.tracker("enableErrorTracking", {
        filter: (errorEvent)=>errorEvent.hasOwnProperty("message")
    });
    /**
   * !IMPORTANT: We are disabling this as to not override Link click config for the impression pixel.
   * Enabling this for impressions will cause click tracking to break
   */ if (event !== "impression") window.tracker("enableLinkClickTracking");
};

});

parcelRegister("8sxXd", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("e9BL7")).then(()=>parcelRequire("111nX"));

});

parcelRegister("1hjWl", function(module, exports) {


module.exports = (parcelRequire("aiXW3"))((parcelRequire("7SZEv")).resolve("7gxBy")).then(()=>parcelRequire("bfVQq"));

});


})();
//# sourceMappingURL=tracker.a852b28d.js.map
